/* eslint-disable @typescript-eslint/no-unused-vars */
import { stepFeature } from "./step.reducer";
import { stepAdapter } from "./step.state";

const entityAdapters = stepAdapter.getSelectors();
const { name, reducer, ...selectors } = stepFeature;

export const stepSelectors = {
  ...entityAdapters,
  ...selectors,
};
